import { Button, Grid, Paper, styled } from "@mui/material";
import { Link } from "react-router-dom";

export const StyledLoginContainer = {
  GridContainer: styled(Grid)(({ theme }) => ({
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundImage: "linear-gradient(120deg, #96d43a, #539aff)",
  })),

  GridRowItem: styled(Grid)({
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  }),

  LogoImage: styled("img")({
    paddingBottom: "40px",
  }),

  LoginCard: styled(Paper)(({ theme }) => ({
    minWidth: "500px",
    maxWidth: "40vw",
    backgroundColor: "white",
    boxShadow: "0px 0px 5px 0px grey",
    borderRadius: "10px",
    padding: "30px 25px 10px 25px",
  })),

  SubmitButton: styled(Button)(({ theme }) => ({
    marginTop: 20,
    backgroundColor: `${theme.palette.primary.gradientLogin2}`,
  })),
};

export const StyledLoginFooter = {
  Footer: styled("div")({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    margin: "0 15px 0 5px",
  }),

  LinkStyled: styled(Link)(({ theme }) => ({
    textDecoration: "none",
    fontFamily: "Roboto, sans-serif",
    fontSize: "small",
    color: theme.palette.primary.backgroundListItem,
    fontWeight: 500,
    "&:hover": {
      color: theme.palette.secondary.dark,
      textDecoration: "underline",
    },
    "&:active": {
      color: theme.palette.secondary.main,
      textDecoration: "none",
    },
  })),
};
